import { RootState } from 'store/root-reducer';
import { MediaNodes } from '../types';

export const getMediaNodes = (state: RootState): MediaNodes | null => state.system.mediaNodes.nodes;

export const isLoading = (state: RootState): boolean => state.system.mediaNodes.isLoading;

export const getMediaClusterSettings = (state: RootState): any => state.system.mediaNodes.settings;
